export default {
    "entityName": "customer",
    // "title": "Country",
    "id": ['code'],
    "pagination": {
        "rowsPerPage": 10,
        "page": 1,
        "sortBy": "id",
        "descending": false
    },
    "fields": [
       
        {
            "value": "_id",
            "text": "ID",
            title: "ID",
            readonly: item => { return item._exists},
            // subtitle: item => `${item.name}`,
            "type": "text",
            "table": {
                "sortable": true,
                filter: true
            },
            render: (item) => {
                return item.id;
            },
        },
        {
            "value": "organization",
            "text": "Organization",
            title: "Organization",
            // subtitle: item => `${item.name}`,
            "type": "text",
            "table": {
                "sortable": true,
                filter: true
            },
            validators: ['required'],
        },
        {
            "value": "first_name",
            "text": "First Name",
            title: "first_name",
            // subtitle: item => `${item.name}`,
            "type": "text",
            "table": {
                "sortable": true,
                filter: true
            },
            validators: ['required'],
        },
        {
            "value": "last_name",
            "text": "Last Name",
            title: "last_name",
            // subtitle: item => `${item.name}`,
            "type": "text",
            "table": {
                "sortable": true,
                filter: true
            },
            validators: ['required'],
        },
        {
            "value": "gender",
            "text": "Gender",
            title: "gender",
            type: "list",
            // subtitle: item => `${item.name}`,
            "list": [1,2],
            "table": {
                "sortable": true,
                filter: true
            },
            validators: ['required'],
        },
        {
            "value": "email",
            "text": "Email",
            title: "email",
            // subtitle: item => `${item.name}`,
            "type": "text",
            "table": {
                "sortable": true,
                filter: true
            },
            validators: ['required'],
        },

        {
            "value": "source",
            "text": "Source",
            title: "source",
            // subtitle: item => `${item.name}`,
            "type": "text",
            "table": {
                "sortable": true,
                filter: true
            },
            validators: ['required'],
        },
         {
            "value": "domain",
            "text": "Domain",
            title: "domain",
            // subtitle: item => `${item.name}`,
            "type": "text",
            "table": {
                "sortable": true,
                filter: true
            },
            validators: ['required'],
        },
        {
            "value": "sent_at",
            "text": "Sent At",
            title: "sent_at",
            // subtitle: item => `${item.name}`,
            "type": "date",
            "table": {
                "sortable": true,
                filter: true
            },
        },
        {
            "value": "status",
            "text": "Status",
            title: "status",
            // subtitle: item => `${item.name}`,
            "type": "list",
            list: [0,1,2,3],
            "table": {
                "sortable": true,
                filter: true
            },
            validators: ['required'],
        },
    ],
    "actions": [
        "upsert",
        "remove",
    ]
}